import { combineReducers } from 'redux';
import movie from './movie';
import news from './news';
import signIn from './signIn';
import payment from './payment';
import user from './user';
import signUp from './singUp';
import userVerify from './userVerify';
import notification from './notification';
import category from './category';
import payment_movies from './payment_movies';
import category_movies from './category_movies';
import instructor from './instructor';
import signOut from './signOut';
import contact from './contact';
import question_category from './question_category';
import question from './question';
import user_refresh from './user_refresh';
import forgot_password from './forgot_password';
import reset_password from './reset_password';
import license from './license';
import campaign_code from './campaign_code';
import push_token from './push_token';
import cart from './cart';
import discount_pack from './discount_pack';
import bronze_test from './bronze_test';
import homemade from './homemade';
import online_test_log from './online_test_log';
export var reducers = combineReducers({
  movie: movie,
  news: news,
  signIn: signIn,
  payment: payment,
  user: user,
  signUp: signUp,
  userVerify: userVerify,
  notification: notification,
  category: category,
  payment_movies: payment_movies,
  category_movies: category_movies,
  instructor: instructor,
  signOut: signOut,
  contact: contact,
  question_category: question_category,
  question: question,
  user_refresh: user_refresh,
  forgot_password: forgot_password,
  reset_password: reset_password,
  license: license,
  campaign_code: campaign_code,
  push_token: push_token,
  cart: cart,
  discount_pack: discount_pack,
  bronze_test: bronze_test,
  homemade: homemade,
  online_test_log: online_test_log
});